import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ApsServiceService } from '../aps-service.service';

@Component({
  selector: 'app-donations',
  templateUrl: './donations.component.html',
  styleUrls: ['./donations.component.css']
})
export class DonationsComponent implements OnInit {
  donation:boolean=false;
  currentyear:any;
  form = new FormGroup({
    username: new FormControl('',Validators.required),
  })

  get username(): any { return this.form.get('username'); }


  constructor(private searchitem: ApsServiceService,private toastr: ToastrService) { }

  ngOnInit(): void {
    const date = new Date();
    const yearOfDate = date.getFullYear()
    this.currentyear=yearOfDate
  }

  validateEmails = (email) => {

    return email.toLowerCase().match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );

    }

    checklength=(username,length)=>{
      // console.log(username.length);
      if(username.length >= length){
        return true;

      }else{
       return false;
      }
    }
    

  // getDonatioinPage
  submitdata () {
  // console.log('clicked');
  // console.log($("#donnerEmail").val());
  var usermail=$("#donnerEmail").val();
  var username=$("#donnerName").val();
  var Description=$("#description").val();
  // console.log(Description)

  // console.log(this.validateEmails(usermail))
  if(!this.validateEmails(usermail)){
    this.toastr.warning('Please Enter Valid Email')

  }else if( !this.checklength(username,3)) {
    this.toastr.warning('The Name Must Have at Least 3 Characters !..')
  }else if(!this.checklength(Description,6)){ 
    this.toastr.warning('The Description Must Have at Least 6 Characters !..')

  }else{
  this.searchitem.getDonatioinPage(usermail,username,Description).subscribe((responce) => {
    if(responce.status){
      this.donation=true
    }else{
      this.donation=false

    }

  })
  }
}

}
